<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one" style="font-family:'Microsoft YaHei'">
        <div style="width: 50%;margin-top: -15%;margin-left: 15%">
          <div class="page">
            <h3  style="font-size: 65px;color: white;font-weight: bold;text-align: left;"> AI+精准医疗 </h3>
          </div>

          <p  class="slogan" style="color: white;font-weight: bold;font-size: 60px;display: flex;align-items: center;">
<!--            融合临床数据 &nbsp; <img src="@/views/image/log/logo_2.png" style="width: 220px"> &nbsp;创新基因科技-->
            融合临床数据&nbsp; · &nbsp;创新基因科技
          </p>

          <p class="slogan" style="color: white;font-weight: bold;font-size: 60px;display: flex;align-items: center;">
<!--            探索疾病密码 &nbsp; <img src="@/views/image/log/logo_2.png" style="width: 220px"> &nbsp;普惠精准医疗-->
            探索疾病密码&nbsp; · &nbsp;普惠精准医疗
          </p>
        </div>

      </swiper-slide>


      <swiper-slide class="my-slide">
        <el-carousel :interval="5000" arrow="always" :height="getTableHeight + 'px'">
          <el-carousel-item v-for="item in 4" :key="item">
            <div style="width: 100%;height: 100%" class="slide-two1" v-if="item == 1" >
              <div style="width: 20%;height: 30%;padding: 30px;margin-left: 10%">
                <!--  标题 -->
                <div style="display: flex; align-items: center;">
                  <div style="width: 10px; background-color: #48b0c2; height: 55px;border-radius: 20px;"></div>
                  <h1 style="margin-left: 10px;">产品介绍</h1>
                </div>

                <!-- 内容 -->
                <div>
                  <h5 style="margin-top: 10%">分子诊断信息管理系统</h5>
                  <div style="margin-top: 10%;font-size: 18px;padding-left: 30px">
                    <ul>
                      <li>样本：全流程闭环管理</li>
                      <li>数据：生信一体化联网</li>
                      <li>报告：数据结构化编辑</li>
                      <li>解读：生物信息知识库</li>
                    </ul>
<!--                    专注于利用拥有知识产权的基因分析技术，准确找出基因突变位点、候选靶向基因，高维数据分析助力寻找新的靶向药物，为肿瘤个性化治疗提供精准支持。-->
                  </div>
                </div>
              </div>
            </div >
            <div style="width: 100%;height: 100%" class="slide-two2" v-if="item == 2" >
              <div style="width: 20%;height: 30%;padding: 30px;margin-left: 10%">
                <!--  标题 -->
                <div style="display: flex; align-items: center;">
                  <div style="width: 10px; background-color: #48b0c2; height: 55px;border-radius: 20px;"></div>
                  <h1 style="margin-left: 10px;">产品介绍</h1>
                </div>

                <!-- 内容 -->
                <div>
                  <h5 style="margin-top: 10%">基因检测外送监管信息平台</h5>
                  <div style="margin-top: 10%;font-size: 18px;padding-left: 30px">
                    <ul>
                      <li>一体化监管</li>
                      <li>全流程质控</li>
                      <li>合规化管理</li>
<!--                      <li>质控审查流程化</li>-->
                    </ul>
                    <!--                    专注于利用拥有知识产权的基因分析技术，准确找出基因突变位点、候选靶向基因，高维数据分析助力寻找新的靶向药物，为肿瘤个性化治疗提供精准支持。-->
                  </div>
                </div>
              </div>
            </div >
<!--            <div style="width: 100%;height: 100%" class="slide-two" v-if="item == 3" >-->
<!--              <div style="width: 20%;height: 30%;padding: 30px;margin-left: 10%">-->
<!--                &lt;!&ndash;  标题 &ndash;&gt;-->
<!--                <div style="display: flex; align-items: center;">-->
<!--                  <div style="width: 10px; background-color: #48b0c2; height: 55px;border-radius: 20px;"></div>-->
<!--                  <h1 style="margin-left: 10px;">产品介绍</h1>-->
<!--                </div>-->

<!--                &lt;!&ndash; 内容 &ndash;&gt;-->
<!--                <div>-->
<!--                  <h5 style="margin-top: 10%">基因组学临床研究大数据平台</h5>-->
<!--                  <div style="margin-top: 10%;font-size: 15px">-->
<!--                    专注于利用拥有知识产权的基因分析技术，准确找出基因突变位点、候选靶向基因，高维数据分析助力寻找新的靶向药物，为肿瘤个性化治疗提供精准支持。-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div >-->
            <div style="width: 100%;height: 100%" class="slide-two3" v-if="item == 3" >
              <div style="width: 20%;height: 30%;padding: 30px;margin-left: 10%">
                <!--  标题 -->
                <div style="display: flex; align-items: center;">
                  <div style="width: 10px; background-color: #48b0c2; height: 55px;border-radius: 20px;"></div>
                  <h1 style="margin-left: 10px;">产品介绍</h1>
                </div>

                <!-- 内容 -->
                <div>
                  <h5 style="margin-top: 10%">精准医疗辅助决策系统</h5>
                  <div style="margin-top: 10%;font-size: 18px;padding-left: 30px">
                    <ul>
                      <li>基因数据融合临床数据挖掘</li>
                      <li>肿瘤生物医学知识库</li>
                      <li>基于AI的肿瘤方案推荐和辅助诊断</li>
<!--                      <li>成果管理智能化</li>-->
<!--                      <li>学术审查流程化</li>-->
                    </ul>
                    <!--                    专注于利用拥有知识产权的基因分析技术，准确找出基因突变位点、候选靶向基因，高维数据分析助力寻找新的靶向药物，为肿瘤个性化治疗提供精准支持。-->
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 100%;height: 100%" class="slide-two4" v-if="item == 4">
              <div style="width: 20%;height: 30%;padding: 30px;margin-left: 10%">
                <!--  标题 -->
                <div style="display: flex; align-items: center;">
                  <div style="width: 10px; background-color: #48b0c2; height: 55px;border-radius: 20px;"></div>
                  <h1 style="margin-left: 10px;">产品介绍</h1>
                </div>

                <!-- 内容 -->
                <div>
                  <h5 style="margin-top: 10%">智慧科研管理信息系统</h5>
                  <div style="margin-top: 10%;font-size: 18px;padding-left: 30px">
                    <ul>
                      <li>科研办公平台化</li>
                      <li>项目管理闭环化</li>
                      <li>经费管理精细化</li>
                      <li>成果管理智能化</li>
                      <li>学术审查流程化</li>
                    </ul>
<!--                    专注于利用拥有知识产权的基因分析技术，准确找出基因突变位点、候选靶向基因，高维数据分析助力寻找新的靶向药物，为肿瘤个性化治疗提供精准支持。-->
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </swiper-slide>


      <swiper-slide class="swiper-slie3 slide-three3">
        <div style="margin-top: -20%;width: 80%">
          <!--  标题 -->
          <div style="display: flex; align-items: center;">
            <div style="width: 10px; background-color: #48b0c2; height: 55px;border-radius: 20px"></div>
            <h1 style="margin-left: 10px;">合作案例</h1>
          </div>

          <div style="display: flex;justify-content: center;align-items: center;margin-top: 2%">
            <div
                class="text-container"
                :class="{ underline: activeIndex === 0 }"
                @click="setActive(0)"
            >
              医疗机构
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div
                class="text-container"
                :class="{ underline: activeIndex === 1 }"
                @click="setActive(1)"
            >
              合作伙伴
            </div>
          </div>

          <!-- 合作伙伴 -->
          <div style="width: 100%;margin-top: 5%;">
            <el-row :gutter="30" v-if="activeIndex === 0">
              <el-col :span="6">
                <div class="hzhbLogClass5"></div>
              </el-col>
              <el-col :span="6">
                <div class="hzhbLogClass1"></div>
              </el-col>
              <el-col :span="6">
                <div class="hzhbLogClass2"></div>
              </el-col>
              <el-col :span="6">
                <div class="hzhbLogClass3"></div>
              </el-col>
            </el-row>
            <el-row :gutter="30" v-if="activeIndex === 0" style="margin-top: 50px">
              <el-col :span="6">
                <div class="hzhbLogClass4"></div>
              </el-col>
            </el-row>

            <el-row :gutter="30" v-if="activeIndex === 1">
              <el-col :span="6">
                <div style="width: 100%;height: 70px"></div>
              </el-col>
              <el-col :span="6">
              </el-col>
              <el-col :span="6">
              </el-col>
              <el-col :span="6">
              </el-col>
            </el-row>
          </div>
        </div>

        <div style="position: absolute;bottom: 0;width: 100%;height: 150px;background-color: #0d2e4b; display: flex;align-items: center;justify-content: center;">
          <div style="width: 80%;color: white;font-size: 14px;margin-top: 1%" >
            <el-row>
              <el-col :span="6">
                <div style="width: 100%; text-align: center;margin-top: -5px">
                  <img src="@/views/image/tail/Vector.png" style="width: 30px">
<!--                  <div>地址</div>-->
                  <div>山东省-济南市-槐荫区-保利中科创新广场-9#1203室</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div style="width: 100%; text-align: center;">
                  <img src="@/views/image/tail/电话.png" style="width: 30px">
                  <div>17600617799</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div style="width: 100%; text-align: center;">
                  <img src="@/views/image/tail/邮箱.png" style="width: 30px">
                  <div>sdysw@gmail.com</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div style="width: 100%; text-align: center;">
                  <img src="@/views/image/tail/更多.png" style="width: 30px">
                  <div>了解更多</div>
                </div>
              </el-col>
            </el-row>
            <div style="text-align: center;margin-top: 1%">山东医数为信息技术有限公司 Copyright 2022 SRlP All rights Reservd</div>
          </div>
        </div>
      </swiper-slide>


    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: false,
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        },
      },
      slideHeight:890,
      screenHeight: document.documentElement.clientHeight,
      activeIndex: 0, // 默认第一个div有下划线
    };
  },
  created() {},
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    getTableHeight() {
      return this.screenHeight*0.93
    }
  },
  mounted() {
    // 窗口或页面被调整大小时触发事件
    window.onresize = () => {
      // 获取body的高度
      this.screenHeight = document.documentElement.clientHeight
    }
  },
  methods: {
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的div
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-slide {
  font-size: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;
    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}
//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  //background: url(./image/home/home_1.png) no-repeat center;
  background: url(./image/home/home_1.png) no-repeat center;
  background-size: cover;
}
//.slide-two2 {
//  background: url(./image/home/home_1.png) no-repeat center;
//  //background: url(../assets/img/home_do.jpg) no-repeat center;
//  background-size: cover;
//}
//.slide-three {
//  background: url(../assets/img/home_anli.jpg) no-repeat center;
//  background-size: cover;
//}



.slide-two1 {
  background: url(./image/home/分子诊断背景.png) no-repeat center;
  //background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-two2 {
  background: url(./image/home/基因检测背景.png) no-repeat center;
  //background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-two3 {
  background: url(./image/home/精准医疗背景.png) no-repeat center;
  //background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-two4 {
  background: url(./image/home/home_2.2.png) no-repeat center;
  //background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
















.page-title {
  font-size: 32px;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4); /* 提升标题可见性 */
  border-bottom: 2px solid #ffffff;
  display: inline-block;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.partner-card {
  transition: transform 0.3s, box-shadow 0.3s;
  background: rgba(255, 255, 255, 0.8); /* 卡片透明背景 */
  border-radius: 12px; /* 圆角 */
}

.partner-card:hover {
  transform: translateY(-5px);
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2);
}

.hzhbClass {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  font-family: "Helvetica", "Arial", sans-serif;
  line-height: 1.5;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px; /* 固定高度，确保布局一致 */
}

///* 添加背景装饰样式 */
//.swiper-slide3.slide-three3::before {
//  content: '';
//  position: absolute;
//  top: 20%;
//  left: 10%;
//  width: 80%;
//  height: 60%;
//  background: rgba(255, 255, 255, 0.1);
//  border-radius: 20px;
//  z-index: 1;
//  filter: blur(10px);
//
//}
.slide-three3{
  background-color: #F0F5FB;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}





.hzhbLogClass{
  background: url(./image/home/home_3_1.png) no-repeat center;
  background-size: cover;
  width: 100%;
  height: 150px;
}

.hzhbLogClass1{
  background: url(./image/home/home_3_jszl.png) no-repeat center;
  background-size: cover;
  width: 100%;
  height: 70px;
}
.hzhbLogClass2{
  background: url(./image/home/home_3_ytyhd.png) no-repeat center;
  background-size: cover;
  width: 100%;
  height: 70px;
}
.hzhbLogClass3{
  background: url(./image/home/home_3_njykdx.png) no-repeat center;
  background-size: cover;
  width: 100%;
  height: 70px;
}
.hzhbLogClass4{
  background: url(./image/home/home_3_zbslyy.png) no-repeat center;
  background-size: cover;
  width: 100%;
  height: 70px;
}
.hzhbLogClass5{
  background: url(./image/home/home_3_sddxqldeyy.png) no-repeat center;
  background-size: cover;
  width: 100%;
  height: 70px;
}






// ======================================= 医疗机构
.text-container {
  padding: 10px;
  margin: 10px 0;
  cursor: pointer;
  font-family: 'Arial', sans-serif;
  font-size: 18px;
  color: #333;
  transition: all 0.3s ease; /* 平滑过渡效果 */
}

.underline {
  position: relative;
  font-weight: bold;
}

.underline::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -5px; /* 调整下划线与文字的间距 */
  height: 3px; /* 下划线的粗细 */
  background-color: #000; /* 下划线的颜色 */
}
// ======================================= 医疗机构
li {
  margin-top: 10px;
  font-weight: bold;
}
</style>
